module.exports = ".mainVideos {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row; }\n\ndiv video {\n  margin-right: 30px;\n  margin-top: 12px;\n  margin-bottom: 30px; }\n\ndiv video.rightRow {\n    margin-right: 0px; }\n\n.videoTitle {\n  font-size: 15px;\n  color: #4f4f4f;\n  font-weight: 500;\n  margin-bottom: 12px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/tutorial/video-tutorial/video-tutorial.component.scss
// module id = ./src/app/shared/components/tutorial/video-tutorial/video-tutorial.component.scss
// module chunks = main